import { Provider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';
import { Toast } from '@base-ui/react/toast';
import { Tooltip } from '@base-ui/react/tooltip';
import { history, store } from '@/redux/lib/configureStore.js';
import toastManager from '@/lib/toast/toastManager.js';
import PlatformRouter from './components/platform/PlatformRouter.jsx';
import SessionHandler from './components/platform/SessionHandler.jsx';
import ThemeHandler from './components/platform/ThemeHandler.jsx';
import ToastViewport from './components/patterns/ToastViewport.jsx';

/** App host: store, router, theme, session, and the providers every screen relies on (tooltips, toasts). */
const Platform = () => {
  return (
    <Provider store={store}>
      <HistoryRouter history={history}>
        <Toast.Provider toastManager={toastManager} timeout={5000}>
          <Tooltip.Provider delay={400}>
            <ThemeHandler />
            <SessionHandler />
            <PlatformRouter />
            <ToastViewport />
          </Tooltip.Provider>
        </Toast.Provider>
      </HistoryRouter>
    </Provider>
  );
};

export default Platform;
